import { trackMetaEvent } from "@/lib/metaCapi";
import { MessageCircle } from "lucide-react";
import type { ButtonHTMLAttributes } from "react";

export const WHATSAPP_NUMBER = "5547992190500";

export function buildWhatsAppUrl(message?: string) {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}

interface WhatsAppLinkProps {
  message?: string;
  source: string; // ex: "hero", "contato-side", "footer"
  className?: string;
  children: React.ReactNode;
  ariaLabel?: string;
}

/** Anchor that fires Meta CAPI Contact event on click */
export const WhatsAppLink = ({
  message,
  source,
  className,
  children,
  ariaLabel,
}: WhatsAppLinkProps) => {
  const url = buildWhatsAppUrl(message);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackMetaEvent({ eventName: "Lead" });
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("whatsapp-click", { detail: { source } })
      );
      // window.open escapa o sandbox do iframe de preview
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      aria-label={ariaLabel}
      className={className}
    >
      {children}
    </a>
  );
};

export const WhatsAppIcon = MessageCircle;

export type WhatsAppButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;
